import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LocusRobotics_ds_get_shipping_containers_ready_to_queueService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { shipmentIds?: number[] }): 
  Promise<{ result: { Id?: number, Height?: number, Length?: number, LookupCode?: string, Weight?: number, Width?: number, ShipmentLinesForExpectedShippingContainer?: { ExpectedPackagedAmount?: number, OrderLineNumber?: number, ExpectedPackaged?: { Name?: string } }[], TasksForExpectedTargetShippingContainer?: { Id?: number, OrderId?: number, Lot?: { LookupCode?: string }, Material?: { Description?: string, LookupCode?: string }, Project?: { Name?: string }, ExpectedSourceLocation?: { Name?: string, ParentLocationContainer?: { Name?: string, ParentLocationContainer?: { Name?: string } } }, ExpectedPackagedPack?: { Height?: number, Length?: number, Name?: string, ShortName?: string, Weight?: number, Width?: number } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { shipmentIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Height?: number, Length?: number, LookupCode?: string, Weight?: number, Width?: number, ShipmentLinesForExpectedShippingContainer?: { ExpectedPackagedAmount?: number, OrderLineNumber?: number, ExpectedPackaged?: { Name?: string } }[], TasksForExpectedTargetShippingContainer?: { Id?: number, OrderId?: number, Lot?: { LookupCode?: string }, Material?: { Description?: string, LookupCode?: string }, Project?: { Name?: string }, ExpectedSourceLocation?: { Name?: string, ParentLocationContainer?: { Name?: string, ParentLocationContainer?: { Name?: string } } }, ExpectedPackagedPack?: { Height?: number, Length?: number, Name?: string, ShortName?: string, Weight?: number, Width?: number } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { shipmentIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Height?: number, Length?: number, LookupCode?: string, Weight?: number, Width?: number, ShipmentLinesForExpectedShippingContainer?: { ExpectedPackagedAmount?: number, OrderLineNumber?: number, ExpectedPackaged?: { Name?: string } }[], TasksForExpectedTargetShippingContainer?: { Id?: number, OrderId?: number, Lot?: { LookupCode?: string }, Material?: { Description?: string, LookupCode?: string }, Project?: { Name?: string }, ExpectedSourceLocation?: { Name?: string, ParentLocationContainer?: { Name?: string, ParentLocationContainer?: { Name?: string } } }, ExpectedPackagedPack?: { Height?: number, Length?: number, Name?: string, ShortName?: string, Weight?: number, Width?: number } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
